import { Language } from "../const";

export type CareerInternData = {
  company: string;
  jobTitle: string;
  major: string;
  year: string;
  detail: string; // under https://www.hkctc.gov.hk
};

export const internLanguageMap: Record<Language, string> = {
  [Language.EN]: "/data/en/intern-en.json",
  [Language.TC]: "/data/tc/intern-tc.json",
  [Language.SC]: "/data/sc/intern-sc.json",
};

export function getCareerInternshipData(
  intern_json: any[]
): CareerInternData[] {
  return intern_json?.flatMap(({ company, detail, job }) =>
    job.map((j: any, index: number) => ({
      company: !index ? company : "", // Only the first job keeps the company name
      jobTitle: j?.title,
      major: j?.major,
      year: j?.year,
      detail: !index ? detail : "", // Only the first job keeps the detail link
    }))
  );
}
